import {
    updateCORNumberRequest,
    grabChangeOrders,
    grabChangeOrder,
    grabEligibleWorkOrders,
    createChangeOrderRequest,
    addWorkOrdersRequest,
    removeWorkOrderRequest,
    voidChangeOrderRequest,
    noChargeChangeOrderRequest,
    completeChangeOrderRequest,
    updateNotesRequest,
    setWorkOrderCONumberRequest,
    setWorkOrderCONumbersBatchRequest,
    clearWorkOrderCONumberRequest
} from "../dataLayer/changeOrders";

class ChangeOrdersManager {

    // Navigation / view state (mirrors WorkOrdersManager)
    selectedChangeOrderID: number = 0;
    selectedJobNumber: string = "";
    selectedStatusFilter: number | "" = "";
    selectedSearch: string = "";

    async getChangeOrders(status?: number, search?: string): Promise<any> {
        try {
            return await grabChangeOrders(status, search);
        } catch (error) {
            console.error("Error during grabbing change orders:", error);
            throw error;
        }
    }

    async getChangeOrder(changeOrderID: number): Promise<any> {
        try {
            return await grabChangeOrder(changeOrderID);
        } catch (error) {
            console.error("Error during grabbing change order:", error);
            throw error;
        }
    }

    async getEligibleWorkOrders(jobNumber: string, keyword?: string): Promise<any> {
        try {
            return await grabEligibleWorkOrders(jobNumber, keyword);
        } catch (error) {
            console.error("Error during grabbing eligible work orders:", error);
            throw error;
        }
    }

    async createChangeOrder(payload: { jobNumber: string; workOrderIDs: number[]; notes?: string; corNumber?: number }): Promise<any> {
        try {
            return await createChangeOrderRequest(payload);
        } catch (error) {
            console.error("Error creating change order:", error);
            throw error;
        }
    }

    async addWorkOrders(changeOrderID: number, workOrderIDs: number[]): Promise<any> {
        try {
            return await addWorkOrdersRequest(changeOrderID, workOrderIDs);
        } catch (error) {
            console.error("Error adding work orders to change order:", error);
            throw error;
        }
    }

    async removeWorkOrder(changeOrderID: number, workOrderID: number): Promise<any> {
        try {
            return await removeWorkOrderRequest(changeOrderID, workOrderID);
        } catch (error) {
            console.error("Error removing work order from change order:", error);
            throw error;
        }
    }

    async voidChangeOrder(changeOrderID: number, reason: string): Promise<any> {
        try {
            return await voidChangeOrderRequest(changeOrderID, reason);
        } catch (error) {
            console.error("Error voiding change order:", error);
            throw error;
        }
    }

    async markNoCharge(changeOrderID: number, reason: string): Promise<any> {
        try {
            return await noChargeChangeOrderRequest(changeOrderID, reason);
        } catch (error) {
            console.error("Error marking change order as no charge:", error);
            throw error;
        }
    }

    async markCompleted(changeOrderID: number): Promise<any> {
        try {
            return await completeChangeOrderRequest(changeOrderID);
        } catch (error) {
            console.error("Error completing change order:", error);
            throw error;
        }
    }

    async updateCORNumber(changeOrderID: number, corNumber: number): Promise<any> {
        try {
            return await updateCORNumberRequest(changeOrderID, corNumber);
        } catch (error) {
            console.error("Error updating COR number:", error);
            throw error;
        }
    }

    async updateNotes(changeOrderID: number, notes: string): Promise<any> {
        try {
            return await updateNotesRequest(changeOrderID, notes);
        } catch (error) {
            console.error("Error updating change order notes:", error);
            throw error;
        }
    }

    async setWorkOrderCONumber(workOrderID: number, coNumber: string): Promise<any> {
        try {
            return await setWorkOrderCONumberRequest(workOrderID, coNumber);
        } catch (error) {
            console.error("Error setting work order CO number:", error);
            throw error;
        }
    }

    async setWorkOrderCONumbers(changeOrderID: number, workOrderIDs: number[], coNumber: string): Promise<any> {
        try {
            return await setWorkOrderCONumbersBatchRequest(changeOrderID, workOrderIDs, coNumber);
        } catch (error) {
            console.error("Error setting change order CO numbers:", error);
            throw error;
        }
    }

    async clearWorkOrderCONumber(workOrderID: number): Promise<any> {
        try {
            return await clearWorkOrderCONumberRequest(workOrderID);
        } catch (error) {
            console.error("Error clearing work order CO number:", error);
            throw error;
        }
    }

}

export default new ChangeOrdersManager();
